module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pg-year"
  }, [(_vm.isEmpty) ? _c('div', {
    staticClass: "my-empty"
  }, [_c('p', [_vm._v("大学が公表している合格者得点がありません。")]), _vm._v(" "), _c('dl', {
    staticClass: "my-empty__reference"
  }, [_c('dt', [_vm._v("参考情報")]), _vm._v(" "), _c('dd', [_vm._v("合格目標ラインは"), _c('a', {
    attrs: {
      "href": _vm.goalLineUrl,
      "target": "_blank"
    }
  }, [_vm._v("こちら")]), _vm._v("をご確認ください。"), _c('br'), _vm._v("※合格目標ラインがない大学は表示されません。")])]), _vm._v(" "), _vm._m(0)]) : _c('div', [_c('section', [_c('h3', {
    staticClass: "mdTtl03"
  }, [_vm._v("センター試験の目標得点シミュレーション")]), _vm._v(" "), _c('p', {
    staticClass: "my-linkto-about"
  }, [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "vam",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showAboutWindow(_vm.isCenter ? '1' : '2')
      }
    }
  }, [_vm._v("表の見方はこちら")])], 1), _vm._v(" "), _vm._l((['avg', 'min']), function(dataKey) {
    return _c('div', {
      key: dataKey,
      staticClass: "my-block"
    }, [_c('h4', {
      staticClass: "my-block__header mdTtl05"
    }, [_vm._v("【合格者" + _vm._s(_vm.MESSAGES[dataKey]) + "点の得点" + _vm._s(_vm.isCenter ? '率' : '') + "を目標にした場合】")]), _vm._v(" "), (!_vm.mydata[dataKey]) ? _c('p', [_vm._v("大学が公表している合格者の" + _vm._s(_vm.MESSAGES[dataKey]) + "点はありません。")]) : _c('div', [(_vm.isCenter) ? _c('div', [_c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("合格者" + _vm._s(_vm.MESSAGES[dataKey]) + "得点率")]), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body"
    }, [_c('span', {
      staticClass: "my-wrap"
    }, [_c('span', {
      staticClass: "my-accent-num"
    }, [_vm._v(_vm._s(_vm._f("score")(_vm.mydata[dataKey].per * 100)))]), _vm._v("%")]), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("（" + _vm._s(_vm._f("score")(_vm.mydata[dataKey].score)) + "点/" + _vm._s(_vm.mydata.max) + "点）")])])]), _vm._v(" "), _c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("\n                あなたの自己採点得点率\n                "), _c('dn-icon', {
      staticClass: "my-box__icon-self",
      attrs: {
        "icon": "self",
        "btn": "",
        "href": _vm.selfUrl,
        "target": "_blank",
        "title": (_vm.year + "年度 自己採点")
      }
    })], 1), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body"
    }, [(_vm.hasTotals) ? _c('div', [_c('span', {
      staticClass: "my-wrap"
    }, [_c('span', {
      staticClass: "my-accent-num"
    }, [_vm._v(_vm._s(_vm._f("score")(_vm.totalHistory.per * 100)))]), _vm._v("%")]), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("（" + _vm._s(_vm.totalHistory.score) + "点/" + _vm._s(_vm.totalHistory.max) + "点）")])]) : _c('div', [_c('span', {
      staticClass: "my-empty-score"
    }, [_vm._v(_vm._s(_vm.MESSAGES.emptyScore))]), _vm._v(" "), _c('dn-icon', {
      staticClass: "my-empty-icon",
      attrs: {
        "icon": "question",
        "btn": "",
        "title": "自己採点について"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showSelfCheckDialog($event)
        }
      }
    })], 1)])]), _vm._v(" "), _c('hr', {
      staticClass: "dn-divider-tri--down"
    }), _vm._v(" "), _c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("センター試験であと何点伸ばそう")]), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body my-accent-num",
      class: ( _obj = {}, _obj[("my-color-" + (_vm.mydata[dataKey].need <= 1 && _vm.mydata[dataKey].need !== null ? 'success' : 'alert'))] = true, _obj )
    }, [(_vm.hasTotals) ? _c('div', [_c('span', {
      staticClass: "my-wrap"
    }, [_vm._v(_vm._s(_vm._f("score")(_vm.mydata[dataKey].need)) + "点")]), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("/" + _vm._s(_vm.totalHistory.max) + "点")])]) : _c('div', [_c('span', {
      staticClass: "my-empty-score"
    }, [_vm._v(_vm._s(_vm.MESSAGES.emptyScore))])])])])]) : _vm._e(), _vm._v(" "), (_vm.isTotal) ? _c('div', [_c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("合格者" + _vm._s(_vm.MESSAGES[dataKey]) + "点")]), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body"
    }, [_c('span', {
      staticClass: "my-wrap"
    }, [_vm._v(_vm._s(_vm._f("score")(_vm.mydata[dataKey].score)) + "点")]), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("/" + _vm._s(_vm._f("score")(_vm.mydata.max)) + "点")])])]), _vm._v(" "), _c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("\n                あなたの自己採点得点\n                "), _c('dn-icon', {
      staticClass: "my-box__icon-self",
      attrs: {
        "icon": "self",
        "btn": "",
        "href": _vm.selfUrl,
        "target": "_blank",
        "title": (_vm.year + "年度 自己採点")
      }
    })], 1), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body"
    }, [(_vm.hasTotals) ? _c('div', [_c('span', {
      staticClass: "my-wrap"
    }, [_vm._v(_vm._s(_vm.totalHistory.score) + "点")]), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("/" + _vm._s(_vm.totalHistory.max) + "点")])]) : _c('div', [_c('span', {
      staticClass: "my-empty-score"
    }, [_vm._v(_vm._s(_vm.MESSAGES.emptyScore))]), _vm._v(" "), _c('dn-icon', {
      staticClass: "my-empty-icon",
      attrs: {
        "icon": "question",
        "btn": "",
        "title": "自己採点について"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showSelfCheckDialog($event)
        }
      }
    })], 1)])]), _vm._v(" "), _c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("個別試験で何点取れるか入れよう")]), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body"
    }, [_c('input', {
      directives: [{
        name: "number-range",
        rawName: "v-number-range"
      }, {
        name: "model",
        rawName: "v-model.lazy",
        value: (_vm.inputSingleScore[dataKey]),
        expression: "inputSingleScore[dataKey]",
        modifiers: {
          "lazy": true
        }
      }],
      staticClass: "my-single-score-input",
      attrs: {
        "type": "number",
        "min": "0",
        "max": _vm.mydata.singleMax
      },
      domProps: {
        "value": (_vm.inputSingleScore[dataKey])
      },
      on: {
        "change": [function($event) {
          _vm.$set(_vm.inputSingleScore, dataKey, $event.target.value)
        }, function($event) {
          _vm.onChangeSingleScore($event, dataKey)
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("/" + _vm._s(_vm.mydata.singleMax) + "点")])])]), _vm._v(" "), _c('hr', {
      staticClass: "dn-divider-tri--down"
    }), _vm._v(" "), _c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("センター試験であと何点伸ばそう")]), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body my-accent-num",
      class: ( _obj$1 = {}, _obj$1[("my-color-" + (_vm.mydata[dataKey].need <= 1 && _vm.mydata[dataKey].need !== null ? 'success' : 'alert'))] = true, _obj$1 )
    }, [_c('span', {
      staticClass: "my-wrap"
    }, [_vm._v(_vm._s(_vm._f("score")(_vm.mydata[dataKey].need)) + "点")]), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("/" + _vm._s(_vm.mydata.max - _vm.mydata.singleMax) + "点")])])])]) : _vm._e()])])
    var _obj;
    var _obj$1;
  }), _vm._v(" "), _c('div', {
    staticClass: "my-annotation"
  }, [_c('p', [_vm._v("※このデータは、" + _vm._s(_vm.year) + "年７月までに弊社が収集した各大学公表の情報を元に作成しており、合格最低点・平均点が公表されている募集単位のみ掲載しています。")]), _vm._v(" "), _c('p', [_vm._v("※「センター試験であと何点伸ばそう」の点数はあくまでも参考点です。この点数を伸ばすと必ず志望大に合格するといったものではありません。")])])], 2), _vm._v(" "), _c('section', {
    staticClass: "mt30"
  }, [_c('h3', {
    staticClass: "mdTtl03"
  }, [_vm._v("どの教科・科目で伸ばすか？")]), _vm._v(" "), _c('p', [_vm._v("センター試験平均点と自己採点結果を比較し、差の大きい教科・科目から優先的に学習しよう")]), _vm._v(" "), _c('div', {
    staticClass: "tac mt40"
  }, [_c('dn-btn', {
    attrs: {
      "block-sp": "",
      "primary": "",
      "width-lg": "",
      "href": _vm.avgScoreInfoUrl,
      "target": "_blank"
    }
  }, [_vm._v("平均点情報")])], 1)])]), _vm._v(" "), _c('dn-dialog', {
    ref: "selfCheckDialog"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("自己採点結果が入力されていません。")]), _vm._v(" "), _c('p', [_vm._v("「"), _c('a', {
    attrs: {
      "href": ("../self/index.html?year=" + _vm.year)
    }
  }, [_vm._v("過去のセンター試験の自己採点をする")]), _vm._v("」から、自己採点を行ってください。")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    attrs: {
      "block-sp": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$refs.selfCheckDialog.hide($event)
      }
    }
  }, [_vm._v("閉じる")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "my-empty__footer"
  }, [_c('dt', [_vm._v("主催")]), _vm._v(" "), _c('dd', [_vm._v("データネット実行委員会"), _c('wbr'), _vm._v("ベネッセコーポレーション"), _c('wbr'), _vm._v("／駿台予備学校")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66d1fd4b","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/bible/myuniv/ScoreYear.vue
// module id = 859
// module chunks = 8